
<!-- Quick View Panel Code  -->
<p-drawer styleClass="u ui-sidebar-lg addfdid" [style]="{ 'width': 'auto', 'max-width': '500px', 'height': 'auto', 'overflow-y': 'auto', 'max-height': '100%'}" 
[(visible)]="show" (onHide)="onClickClose(false)" position="right" [baseZIndex]="10000" appendTo="body">
<form #addFdid="ngForm" (ngSubmit)="onClickSave(addFdid)">    
<div class="ui-grid ui-grid-responsive ui-fluid">
        @if(selectedFdid){
        <div id="fdidTitle">
            <h3 class="ui-grid-col-12">FDID Details</h3>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="CatReporterIMID">CatReporterIMID</label>
                </div>
                <div class="ui-grid-col-9 quick-view-grid-row">
                    <input required [disabled]="true" name="catReporterIMID" id="catReporterIMID" pInputText [(ngModel)]="selectedFdid.catReporterIMID" style="width:100%" />
                </div>
            </div>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="AccountNumber">Account Number <span class="required-asterisk">*</span></label>
                </div>
                <div class="ui-grid-col-9 quick-view-grid-row">
                    <p-autoComplete required [readonly]="isDisableAccountNumber" [style]="{ 'width': '93% !important'}" id="accountNumber" name="accountNumber" [(ngModel)]="selectedAccountNumber" [suggestions]="filteredAccountNumber" (completeMethod)="filterAccountNumber($event)" field="label"
                     placeholder="Account Number" [minLength]="1" (onSelect)="getAccountDetails(selectedAccountNumber)" #accountNumber="ngModel" [class.invalid-field]="accountNumber.invalid && (accountNumber.touched || accountNumber.dirty)">
                   
                       <ng-template let-brand pTemplate="item">
                           <div  class="ui-helper-clearfix" style="border-bottom:1px solid #D5D5D5">
                               <div style="font-size:14px;float:left;margin:10px 10px 0 0">
                                   {{brand.label}}
                               </div>
                           </div>
                       </ng-template>
                   </p-autoComplete>
                <p-button type="button" class="checkmark" [disabled]="!selectedAccountNumber || isDisableAccountNumber" icon="fa fa-check" id="catExceptionSave" (click)="getAccountDetails({label: selectedAccountNumber})"> </p-button>
                </div>
            </div>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="Name">Name <span class="required-asterisk">*</span></label>
                </div>
                <div class="ui-grid-col-9 quick-view-grid-row">
                    <input required [disabled]="isDisable" name="name" id="name" pInputText [(ngModel)]="selectedFdid.name" style="width:100%" 
                     #name="ngModel" [class.invalid-field]="name.invalid && (name.touched || name.dirty)"/>
                </div>
            </div>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="GivenName">Given Name <span class="required-asterisk">*</span></label>
                </div>
                <div class="ui-grid-col-9 quick-view-grid-row">
                    <input required [disabled]="isDisable"  name="givenName" id="givenName" pInputText [(ngModel)]="selectedFdid.givenName" style="width:100%" 
                     #givenName="ngModel" [class.invalid-field]="givenName.invalid && (givenName.touched || givenName.dirty)"/>
                </div>
            </div>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                <label for="GeneratedFDID">Generated FDID</label>
                </div>
                <div class="ui-grid-col-9 quick-view-grid-row">
                    <input required pInputText name="fdid" id="fdid" [(ngModel)]="selectedFdid.fdid" readonly style="background-color:#ebebe4; width: 100%;outline:none"/>
                    <button type="button" [disabled]="isDisableFDID || (selectedFdid.receivedFdid!=undefined && selectedFdid.receivedFdid.length>0)" 
                        (click)="isDisableFDID ? '' : generateFDID()">Generate FDID</button>
                </div>
            </div>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="ReceivedFDID">Received FDID <span class="required-asterisk">*</span></label>
                </div>
                <div class="ui-grid-col-9 quick-view-grid-row">
                    <input [disabled]="isDisable || isDisableReceiveFDID" (focusout)="copyReceivedFdid($event)" name="receivedFdid" id="receivedFdid" pInputText [(ngModel)]="selectedFdid.receivedFdid" style="width:100%" 
                    required #receivedFdid="ngModel" [class.invalid-field]="receivedFdid.invalid && (receivedFdid.touched || receivedFdid.dirty)"/>
                </div>
            </div>
            <div class="ui-grid-col-12 buttonStyle">
                @if(isDisableSave){<button pButton type="button" [disabled]="true" label="Save" class="ui-button-info ui-grid-col-1 btn-style pull-right userActionBtn"></button>}
                @if(!isDisableSave){<button pButton type="submit" label="Save" class="ui-button-info ui-grid-col-1 btn-style pull-right userActionBtn"></button>}
                <button pButton type="button" (click)="onClickClose(true)" label="Close" class="ui-button-danger ui-grid-col-1 btn-style pull-right userActionBtn"></button>
                <button pButton type="button" (click)="onClickReset()" label="Reset" class="ui-button-danger ui-grid-col-1 btn-style pull-right userActionBtn"></button>
            </div>
        </div>}
    </div>
<p-confirmDialog styleClass="dialogBox" key="confirmationDialog" appendTo="body" header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-confirmDialog  acceptLabel="Ok" key="informationDialog" [rejectVisible]="false" appendTo="body" header="Information" icon="pi pi-exclamation-triangle"></p-confirmDialog>
</form>
</p-drawer>
